import { Link } from "react-router-dom";
import FaqBlock, { FAQ_SLUGS } from "@/components/FaqBlock";

const CONTENT = {
  about: {
    title: "About Jeweltix",
    body: [
      "Jeweltix is the world's marketplace built exclusively for jewellery CAD design files — 3DM and STL formats only. We connect professional CAD designers with jewellery manufacturers, CAD/CAM studios, and 3D printing units across the globe.",
      "Unlike a retail jewellery store, everything on Jeweltix is a downloadable, production-ready design file. Every listing includes a live 3D technical preview so buyers can inspect topology and geometry before purchasing.",
      "We protect both sides of every transaction with an escrow-based payment system and a full dispute-resolution workflow.",
    ],
  },
  "how-it-works": {
    title: "How it Works",
    body: [
      "1. Browse & preview — Explore thousands of jewellery CAD files. Orbit, zoom and toggle wireframe/metal finish on our live 3D viewer before you buy.",
      "2. Buy securely — Pay via card/UPI/netbanking. You get instant, authenticated download access to the original file.",
      "3. Escrow protection — The seller's earnings are held for 48 hours. If you raise a dispute, the payout freezes until our team resolves it.",
      "4. Sellers get paid — After the 48-hour hold clears with no dispute, funds move to the designer's withdrawable wallet balance.",
    ],
  },
  pricing: {
    title: "Pricing & Commission",
    body: [
      "Buying files is pay-per-download — you only pay the price set by the designer, with lifetime re-download access.",
      "For designers: listing is free. Jeweltix charges a platform commission (default 15%) on each successful sale. The rest is credited to your wallet.",
      "Payouts are made via bank transfer or UPI once your available balance clears the 48-hour escrow hold.",
    ],
  },
  faq: {
    title: "Frequently Asked Questions",
    body: [
      "What file formats are supported? Only .3dm (Rhino, editable) and .stl (print-ready, non-editable).",
      "Can I preview before buying? Yes — every product has a live, watermarked 3D preview. The full-resolution original is delivered only after payment.",
      "What if a file is corrupt or wrong? Raise a dispute from your orders. The seller's payout freezes and our team resolves it (release, refund, partial refund, or file replacement).",
      "How do designers get paid? Earnings clear after a 48-hour escrow hold, then can be withdrawn to bank/UPI.",
    ],
  },
  terms: { title: "Terms of Service", body: ["By using Jeweltix you agree to use purchased CAD files in accordance with the designer's license. Redistribution or resale of downloaded files is prohibited.", "Designers warrant they own the rights to files they upload. Jeweltix reserves the right to remove listings that violate IP rights."] },
  "refund-policy": { title: "Refund & Dispute Policy", body: ["Because CAD files are digital goods, refunds are issued only through the dispute-resolution process for valid issues (corrupt file, wrong file, mismatched design, or not-as-described).", "Disputes must be raised within the escrow window. Our team may resolve with a full refund, partial refund, file replacement, or by releasing payment to the seller if the claim is invalid."] },
  contact: { title: "Contact & Support", body: ["For support, raise a ticket from your dashboard or email support@jeweltix.com.", "Sales & partnerships: partners@jeweltix.com"] },
};

export default function StaticPage({ slug }) {
  const c = CONTENT[slug] || CONTENT.about;
  return (
    <div className="max-w-3xl mx-auto px-6 py-14">
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl">{c.title}</h1>
      <div className="mt-8 space-y-5">
        {c.body.map((p, i) => <p key={i} className="text-muted-foreground leading-relaxed">{p}</p>)}
      </div>
      {slug === "how-it-works" && (
        <FaqBlock title="Payments & escrow — FAQs" slugs={FAQ_SLUGS.howItWorks} testid="how-faq-payments" />
      )}
      <Link to="/marketplace" className="inline-block mt-10 text-primary font-medium">← Back to marketplace</Link>
    </div>
  );
}
